import * as actionTypes from '../constants/actionTypes';

export function redirectAction(path: string) {
  return { type: actionTypes.SET_REDIRECT, path }
}

export function resetRedirectAction() {
  return { type: actionTypes.RESET_REDIRECT }
}